import { isNil, isNull } from 'lodash-es'
import { useRouter, useSearchParams } from 'next/navigation'

const CATEGORY_PARAM = 'categoryId'

export const useCategory = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const categoryId = searchParams?.get(CATEGORY_PARAM)

  const isSelected = (id: number | null) => {
    if (isNull(id)) {
      return isNil(categoryId)
    }

    return id === Number(categoryId)
  }

  const handleChange = (id: number | null) => () => {
    const params = new URLSearchParams(searchParams?.toString() ?? '')

    params.delete('page')

    if (isNull(id)) {
      params.delete(CATEGORY_PARAM)
    } else {
      params.set(CATEGORY_PARAM, id.toString())
    }
    router.push(`?${params.toString()}`)
  }

  return {
    isSelectedCategory: isSelected,
    handleCategoryChange: handleChange,
  }
}
